import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {Hub} from 'yougile-model'
import {ErrorBoundary} from '@components/common/error-boundary/error-boundary'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useSyncEvent} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {StatsPageChart} from './state-page-chart'
import {StatsPageChooser} from './state-page-chooser'
import {StatsPageTable} from './state-page-table'
import {
  StatsPageContext,
  StatsPageStore,
  useStatsPageStore
} from './stats-page-store'

interface StatsPageProps {
  board: Hub
}

export const StatsPage = (props: StatsPageProps) => {
  const [statsPageStore] = useState(() => new StatsPageStore(props.board))

  return (
    <ErrorBoundary
      silent
      onError={e => logger.error('stats page error ' + e.message)}
    >
      <StatsPageContext.Provider value={statsPageStore}>
        <StatsPageBase {...props} />
      </StatsPageContext.Provider>
    </ErrorBoundary>
  )
}

const StatsPageBase = observer(({board}: StatsPageProps) => {
  const [state, store] = useStatsPageStore()

  useSyncEvent(
    'custom',
    {filter: board.id, companyId: board.companyId},
    store.syncOnUpdate,
    [board.id]
  )

  return (
    <div className="stp">
      <div className="stp-cnt">
        <div className="stb-brd">{Lang.msg.tsTitle}</div>

        <div className="stp-body">
          <WithPerfectScrollbar>
            <StatsPageChooser />

            <StatsPageChart />

            <hr className="stp-line" />

            <div className="stp-downloads">
              <div className="stp-excel _link" onClick={store.downloadXLSX}>
                {Lang.msg.tsDownloadXLSX}
              </div>
            </div>

            <div className="stp-include">
              <div
                className={cn(
                  'stp-include-btn',
                  state.table.include === 'all' && 'current'
                )}
                onClick={() => store.tableSetInclude('all')}
              >
                {Lang.msg.tsAll}
              </div>
              <div
                className={cn(
                  'stp-include-btn',
                  state.table.include === 'open' && 'current'
                )}
                onClick={() => store.tableSetInclude('open')}
              >
                {Lang.msg.tsOpen}
              </div>
              <div
                className={cn(
                  'stp-include-btn',
                  state.table.include === 'closed' && 'current'
                )}
                onClick={() => store.tableSetInclude('closed')}
              >
                {Lang.msg.tsClosed}
              </div>
            </div>

            <StatsPageTable />
          </WithPerfectScrollbar>
        </div>
      </div>
    </div>
  )
})
